import {
  HStack,
  VStack,
  Image,
  Text,
  Checkbox,
  Pressable,
  CheckboxIndicator
} from "@gluestack-ui/themed";

import { SelectListItem } from "./types";
import { useMemo } from "react";
import { Icon } from "@repo/core/components/core/Icon";

export const SelectItem = ({
  item,
  isMultiple,
  onSelectItem,
  selectedValues,
  onCloseModal
}: SelectListItem) => {
  const { label, value, subLabel, image } = item;

  const isSelected = useMemo(() => {
    if (Array.isArray(selectedValues)) {
      return selectedValues.includes(value);
    }

    return selectedValues === value;
  }, [selectedValues, value]);

  const handleOnSelect = () => {
    onSelectItem(value);
  };

  return (
    <Pressable onPress={handleOnSelect} flex={1}>
      <HStack gap="$2" py="$6">
        {image ? (
          <HStack>
            <Image
              source={{
                uri: image
              }}
              rounded="$full"
              alt="picture"
              size="xs"
            />
          </HStack>
        ) : null}
        <VStack flex={1} justifyContent="center">
          <Text fontWeight={600} fontSize="$md" color="$textLight700">
            {label}
          </Text>
          {subLabel ? (
            <Text fontSize="$sm" mt="$1" color="$textLight500">
              {subLabel}
            </Text>
          ) : null}
        </VStack>
        {isMultiple ? (
          <HStack alignItems="center" justifyContent="center">
            <Checkbox
              value={value}
              size="md"
              isInvalid={false}
              isDisabled={false}
              isChecked={isSelected}
              aria-label="item"
              onPress={handleOnSelect}
            >
              <CheckboxIndicator aria-label="item" mr="$2">
                {isSelected ? (
                  <Icon name="check" size={12} color="$white" />
                ) : null}
              </CheckboxIndicator>
            </Checkbox>
          </HStack>
        ) : null}
      </HStack>
    </Pressable>
  );
};
